export default {
  account_id_required: "ត្រូវការលេខសម្គាល់គណនី។",
  account_not_exists: "លេខសម្ងាត់មិនត្រឹមត្រូវ។",
  accountIdRequired: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  agent_comm_rate_required: "ត្រូវការអត្រាគម្រោងជាន់អាជេន។",
  agent_id_required: "ត្រូវការលេខសម្គាល់អាជេន។",
  alphaNumOnly: "អក្សរភាសាឡាតាំង និងលេខប៉ុណ្ណោះ",
  atLeastThreeMatchToBetParlay: "ត្រូវការផ្សំពីយ៉ាងតិចបីប្រកួតសម្រាប់ភ្នាល់បែប parlay។",
  atLeastTwoMatchToBetParlay: "ត្រូវការផ្សំពីយ៉ាងតិចពីរប្រកួតសម្រាប់ភ្នាល់បែប parlay។",
  bet_amount_required: "ត្រូវការទំហំភ្នាល់។",
  bet_id_required: "ត្រូវការលេខសម្គាល់ការភ្នាល់។",
  betAmountRequired: "ត្រូវការចំនួនទឹកប្រាក់ភ្នាល់។",
  betExists: "ការភ្នាល់មានរួចហើយ។",
  betLowerMin: "ប្រាក់ភ្នាល់ទាបជាងចំនួនអប្បបរមា។",
  betNotExists: "សូមដាក់ភ្នាល់ដែលត្រឹមត្រូវដើម្បីចូលរួមវគ្គប្រកួត។",
  betOverMax: "ប្រាក់ភ្នាល់លើសចំនួនអតិបរមា។",
  betOverMaxBet: "ប្រាក់ភ្នាល់លើសចំនួនអតិបរមា។",
  betOverMaxPerMatch: "ប្រាក់ភ្នាល់លើសចំនួនអតិបរមា។",
  betTypeRequired: "ត្រូវការប្រភេទភ្នាល់។",
  BLOCK: "គណនីត្រូវបានបាំង!",
  changeStakeMax: "ចំនួនភ្នាល់ត្រូវបានកែប្រែដោយសារលើសអតិបរមា។",
  changeStakeMin: "ចំនួនភ្នាល់ត្រូវបានកែប្រែដោយសារខុសអប្បបរមា។",
  CLOSE: "គណនីត្រូវបានបិទ!",
  close: "គណនីត្រូវបានបិទ! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",
  confirmNewPasswordRequired: "ត្រូវការបញ្ជាក់លេខសម្ងាត់ថ្មី!",
  connectionFailed: "បរាជ័យក្នុងការភ្ជាប់ប្រព័ន្ធកាបូប។",
  containAlphaNum: "{fname} ត្រូវមានអក្សរនិងលេខយ៉ាងហោចណាស់មួយ។",
  "createRoomFailed-1": "បរាជ័យក្នុងការបង្កើតបន្ទប់ 1។",
  "createRoomFailed-2": "បរាជ័យក្នុងការបង្កើតបន្ទប់ 2។",
  "createRoomFailed-3": "បរាជ័យក្នុងការបង្កើតបន្ទប់ 3។",
  credit_amount_required: "ត្រូវការចំនួនបញ្ចូលប្រាក់។",
  currency_required: "ត្រូវការជ្រើសរូបិយប័ណ្ណ។",
  currencyNotSupported: "រូបិយប័ណ្ណនេះមិនត្រូវបានគាំទ្រ។",
  currPasswordRequired: "ត្រូវការលេខសម្ងាត់បច្ចុប្បន្ន!",
  dataError: "បញ្ហាទិន្នន័យ",
  debit_amount_required: "ត្រូវការចំនួនដកប្រាក់។",
  duplicate_credit_record: "កំណត់ត្រាបញ្ចូលប្រាក់ស្ទួន។",
  duplicate_debit_record: "អត្រាកំពុងធ្វើបច្ចុប្បន្នភាព...",
  endDateRequired: "ត្រូវការកាលបរិច្ឆេទបញ្ចប់!",
  EsportsDisabled: "ហ្គេម E-Sports បានបិទ",
  forbiddenAccess: "ការចូលប្រើត្រូវបានហាមឃាត់",
  FREEZE: "គណនីត្រូវបានបង្កក!",
  freeze: "គណនីត្រូវបានបង្កក! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",
  game_maintenance: "ហ្គេមកំពុងថែទាំប្រព័ន្ធ។",
  incompletedRequest: "មានអ្វីមួយខុស...",
  insufficient_balance: "ប្រាក់មិនគ្រប់គ្រាន់",
  invalid_password: "លេខសម្ងាត់មិនត្រឹមត្រូវ។",
  invalidBetAmount: "ចំនួនទឹកប្រាក់ភ្នាល់មិនត្រឹមត្រូវ។",
  invalidBets: "ទីផ្សារនេះមិនមានទេ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",
  invalidCurrency: "រូបិយប័ណ្ណមិនត្រឹមត្រូវសម្រាប់ភ្នាល់។",
  invalidleague: "លីគមិនត្រឹមត្រូវ។",
  invalidMarketType: "ប្រភេទទីផ្សារមិនត្រឹមត្រូវ។",
  invalidMatch: "ការប្រកួតមិនត្រឹមត្រូវ។",
  invalidMember: "សមាជិកមិនត្រឹមត្រូវ។",
  invalidOddsBall: "កំពុងធ្វើបច្ចុប្បន្នភាពអ៊ុត...",
  invalidOperator: "ប្រតិបត្តិករមិនត្រឹមត្រូវ។",
  invalidPassword: "ពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
  invalidRoom: "បន្ទប់មិនត្រឹមត្រូវ។",
  invalidRoomLimit: "ការកំណត់ចំនួនអ្នកលេងមិនត្រឹមត្រូវ។",
  invalidRoomPassword: "PIN មិនត្រឹមត្រូវ។ PIN ត្រូវតែមាន 6 ខ្ទង់ជាលេខ។",
  invalidRoomRate: "អត្រាបន្ទប់មិនត្រឹមត្រូវ។",
  invalidRoomType: "ប្រភេទបន្ទប់មិនត្រឹមត្រូវ។",
  invalidRTSMatchOdds: "អត្រាប្រកួត RTS មិនត្រឹមត្រូវ។",
  invalidSession: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  IPJoinedBefore: "IP នេះបានចូលរួចមកហើយ។",
  isAlpha: "{fname} អាចបញ្ចូលបានតែអក្សរប៉ុណ្ណោះ។",
  isAlphaNum: "{fname} អាចបញ្ចូលបានតែអក្សរនិងលេខ។",
  isEmail: "{fname} ត្រូវតែជាស្ថាប័នអ៊ីមែលត្រឹមត្រូវ។",
  isIpAddress: "{fname} ត្រូវតែជាអាសយដ្ឋាន IPv4 ត្រឹមត្រូវ។",
  isMaxLength: "{fname} ត្រូវមានអក្សរតិចជាង ឬ ស្មើនឹង {fvalue} តួ។",
  isMaxValue: "{fname} ត្រូវតែតិចជាង ឬ ស្មើនឹង {fvalue}។",
  isMinLength: "{fname} ត្រូវមានអក្សរយ៉ាងតិច {fvalue} តួ។",
  isMinValue: "{fname} ត្រូវតែមានតិចបំផុតជា {fvalue}។",
  isNumeric: "{fname} អាចបញ្ចូលបានតែលេខប៉ុណ្ណោះ។",
  isOutrightRequired: "ត្រូវការការជ្រើសរើសទាំងមូល!",
  // vuelidate
  isRequired: "សូមបញ្ចូល {fname}។",
  isSameAs: "{fname} ត្រូវតែដូចនឹង {fname2}។",
  isUrl: "{fname} ត្រូវតែជាអាសយដ្ឋាន URL ត្រឹមត្រូវ។",
  "joinFailed-1": "បរាជ័យក្នុងការចូលបន្ទប់ 1។",
  "joinFailed-2": "បរាជ័យក្នុងការចូលបន្ទប់ 2។",
  leagueIdRequired: "ត្រូវការលេខសម្គាល់លីគ!",
  liveCasinoDisabled: "លៃវ៉ាកាស៊ីណូបានបិទ",
  liveMatchNotAllowed: "មិនអនុញ្ញាតឲ្យប្រកួតបន្តផ្ទាល់។",
  //tournament
  login_id_not_exists: "ការចូលមិនត្រឹមត្រូវ សូមព្យាយាមចូលឡើងវិញ។",
  loginFailed: "ការចូលបរាជ័យ សូមសាកល្បងម្ដងទៀតនៅពេលក្រោយ...",
  loginLimit: "អ្នកបានចូលប្រើញឹកញាប់ពេក សូមសាកល្បងម្ដងទៀតបន្ទាប់ពី 1 នាទី...",
  lotteryDisabled: "សំបុត្រឆ្នោតបានបិទ",
  marketTypeChanged: "សន្លឹកភ្នាល់ត្រូវបានលុបចេញដោយសារប្រភេទទីផ្សារបានផ្លាស់ប្តូរ។<br />សូមជ្រើសវិញពីទីផ្សារថ្មី។",
  marketTypeRequired: "ត្រូវការបញ្ជាក់ប្រភេទទីផ្សារ។",
  master_comm_rate_required: "ត្រូវការអត្រាគម្រោងជាន់មេ។",
  master_id_required: "ត្រូវការលេខសម្គាល់ជាន់មេ។",
  matchDateRequired: "ត្រូវការថ្ងៃការប្រកួត។",
  matchHide: "ទីផ្សារនេះមិនមានទេ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",
  matchLowerMin: "កំហុស៖ ចំនួនប្រកួតតិចជាងអប្បបរមា។",
  matchNotActive: "ការប្រកួតនេះមិនអាចភ្នាល់បានទេ សូមសាកល្បងទីផ្សារប្រកួតផ្សេងទៀត។",
  matchNotAllowBet: "ទីផ្សារនេះមិនមានទេ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",
  matchOverMax: "កំហុស៖ ចំនួនប្រកួតលើសអតិបរមា។",
  matchRequired: "ត្រូវការជ្រើសប្រកួត។",
  maxMatch: "អតិបរមា {max} ប្រកួត!",
  maxParlayTicket: "ឈានដល់ចំនួនសំបុត្រអតិបរមាសម្រាប់ភ្នាល់បញ្ចូលច្រើនប្រកួតរួចហើយ!",
  maxRoomLimit: "ចំនួនអ្នកលេងត្រូវមាន 30 ឬតិចជាងនេះ។",
  maxRoomRate: "ថ្លៃចូលរួមត្រូវមាន 1000 ឬតិចជាងនេះ។",
  member_id_required: "ត្រូវការលេខសម្គាល់សមាជិក។",
  member_wallet_not_exists: "កាបូបសមាជិកមិនមានទេ។",
  memberExists: "សមាជិកមានរួចហើយ។",
  memberJoinedBefore: "អ្នកបានចូលរួចមកហើយ សូមចងចាំថាបន្ទប់សាធារណៈឥតគិតថ្លៃអាចចូលបានតែម្ដងប៉ុណ្ណោះ។",
  minBetAmount: "កំហុស៖ ចំនួនភ្នាល់អប្បបរមា។",
  MiniGameDisabled: "ហ្គេមតូចៗបានបិទ",
  minMatch: "ត្រូវជ្រើសយ៉ាងហោចណាស់ 3 ប្រកួត។",
  minRoomLimit: "ចំនួនអ្នកលេងត្រូវមាន 3 ឬច្រើនជាងនេះ។",
  minRoomRate: "ថ្លៃចូលរួមត្រូវមាន 10 ឬច្រើនជាងនេះ។",
  new_login_id_exists: "សម្មតិនាមមិនត្រឹមត្រូវ សូមសាកល្បងដាក់ឈ្មោះផ្សេងទៀត។",
  newPasswordRequired: "ត្រូវការលេខសម្ងាត់ថ្មី!",
  nickNameRequired: "ត្រូវការសម្មតិនាម!",
  noMatchSelected: "សូមជ្រើសយ៉ាងហោចណាស់ 1 ប្រកួត។",
  notSameAs: "{fname} និង {fname2} មិនអាចដូចគ្នាបានទេ។",
  NoUserAccessRight: "មិនអនុញ្ញាត! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",
  oddsDisplayInvalid: "អត្រាកំពុងធ្វើបច្ចុប្បន្នភាព...",
  oddsIsUpdating: "អត្រាកំពុងធ្វើបច្ចុប្បន្នភាព...",
  OK: "អូខេ",
  pageNumberRequired: "ត្រូវការលេខទំព័រ!",
  pageSizeRequired: "ត្រូវការទំហំទំព័រ!",
  passwordRequired: "ត្រូវការលេខសម្ងាត់!",
  passwordsNotMatch: "លេខសម្ងាត់មិនដូចគ្នាទេ!",
  permission_denied: "មិនមានសិទ្ធិចូលប្រើ។",
  pointsOverLimit: "កំហុស៖ ពិន្ទុលើសកំណត់។",
  rate_required: "ត្រូវការអត្រា។",
  rateLowerMin: "កំហុស៖ អត្រាតិចជាងអប្បបរមា។",
  rateOverMax: "កំហុស៖ អត្រាលើសអតិបរមា។",
  requestFailed: "ការភ្ជាប់របស់អ្នកមិនមានស្ថេរភាព។ សូមពិនិត្យការភ្ជាប់របស់អ្នកហើយសាកល្បងម្ដងទៀត។",
  requestLimit: "អ្នកបានស្នើរញឹកញាប់ពេក។",
  requestPending: "សំណើរនៅរងចាំ...",
  result_exists: "លទ្ធផលមានរួចហើយ។",
  room_id_required: "ត្រូវការលេខសម្គាល់បន្ទប់។",
  roomClosed: "បន្ទប់បានបិទ។",
  roomClosedNotAllowed: "មិនអាចចូលបន្ទប់ដែលបិទ។",
  roomEnded: "បន្ទប់បានបញ្ចប់រួចហើយ។",
  roomEndedOrCancelled: "បន្ទប់បានបញ្ចប់ឬបានលុបចោល។",
  roomExists: "មិនអាចបង្កើតបន្ទប់ឯកជនច្រើនជាង 1 បានទេ។",
  RoomExists: "មិនអាចបង្កើតបន្ទប់ឯកជនច្រើនជាង 1 បានទេ។",
  roomFull: "បន្ទប់ពេញរួចហើយ។",
  roomIdRequired: "ត្រូវការបញ្ចូលលេខសម្គាល់បន្ទប់។",
  roomIsPublicFree: "បន្ទប់នេះជាបន្ទប់សាធារណៈឥតគិតថ្លៃ។",
  roomLimitLowerMin: "កំហុស៖ កំណត់ចំនួនអ្នកលេងតិចជាងអប្បបរមា។",
  roomLimitOverMax: "កំហុស៖ កំណត់ចំនួនអ្នកលេងលើសអតិបរមា។",
  roomLimitRequired: "ត្រូវការកំណត់ចំនួនអ្នកលេង។",
  roomNotExists: "បន្ទប់មិនមានទេ។",
  roomOverMax: "កំហុស៖ បន្ទប់លើសចំនួនអតិបរមា។",
  roomPasswordRequired: "ត្រូវការបញ្ចូល PIN។",
  roomRateRequired: "ត្រូវការកំណត់អត្រាបន្ទប់។",
  roomTypeRequired: "ត្រូវការបញ្ជាក់ប្រភេទបន្ទប់។",
  s_senior_comm_rate_required: "ត្រូវការអត្រាគម្រោង Super Senior។",
  s_senior_id_required: "ត្រូវការលេខសម្គាល់ Super Senior។",
  secondary_account_exists: "អ្នកបានបង្កើតសម្មតិនាមរួចហើយ។",
  selectLeague: "សូមជ្រើសយ៉ាងហោចណាស់ 1 លីគ",
  selectOption: "សូមជ្រើសរើស {fname}",
  senior_comm_rate_required: "ត្រូវការអត្រាគម្រោង Senior។",
  senior_id_required: "ត្រូវការលេខសម្គាល់ Senior។",
  session_expired: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  session_not_exists: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  sessionTokenRequired: "ត្រូវការកូដសម័យប្រើប្រាស់។",
  shareholder_comm_rate_required: "ត្រូវការអត្រាគម្រោងម្ចាស់ភាគហ៊ុន។",
  shareholder_id_required: "ត្រូវការលេខសម្គាល់ម្ចាស់ភាគហ៊ុន។",
  slotDisabled: "ម៉ាស៊ីនស្លុតបានបិទ",
  sportsTypeRequired: "ត្រូវការប្រភេទកីឡា!",
  startDateRequired: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម!",
  SUSPEND: "គណនីរបស់អ្នកត្រូវបានផ្លាស់ប្តូរទៅមើលបានតែប៉ុណ្ណោះ។",
  suspend: "គណនីត្រូវបានផ្អាក! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",
  systemError: "បញ្ហាក្នុងប្រព័ន្ធផ្ទៃក្នុង។",
  tournamentDisabled: "វគ្គប្រកួតត្រូវបានបិទ សូមទាក់ទងអ្នកណែនាំរបស់អ្នក។",
  tournamentLeagueExists: "លីគក្នុងវគ្គប្រកួតមានរួចហើយ។",
  tournamentMatchExists: "ការប្រកួតក្នុងវគ្គប្រកួតមានរួចហើយ។",
  transfer_id_required: "ត្រូវការលេខសម្គាល់ការផ្ទេរ។",
  unableToGetBalanceAtTheMoment: "បញ្ហាជាមួយម៉ាស៊ីនមេ។",
  usernameRequired: "ត្រូវការឈ្មោះអ្នកប្រើប្រាស់!",
  workingDateRequired: "ត្រូវការកាលបរិច្ឆេទធ្វើការ!",
  matchNotStarted: "ការប្រកួតមិនបានចាប់ផ្តើមទេ។",
  cashOutUnavailable: "ការផ្ទេរមិនអាចប្រើបានទេ។",
  errorCashoutAmount: "ការផ្ទេរកំពុងធ្វើបច្ចុប្បន្នភាព...",
  invalidParameter: "មិនមានតម្រូវការទេ។",
  startTimeRequired: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម!",
  endTimeRequired: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម!",
  oddsTypeIDRequired: "ត្រូវការប្រភេទអត្រា!",
  commissionRequired: "ត្រូវការការផ្ទេរ!",
  requestTimeRequired: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម!",
  statusRequired: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម!",
  invalidStartTime: "កាលបរិច្ឆេទចាប់ផ្តើមមិនត្រឹមត្រូវទេ!",
  invalidEndTime: "កាលបរិច្ឆេទចាប់ផ្តើមមិនត្រឹមត្រូវទេ!",
  invalidOddsTypeID: "ប្រភេទអត្រាមិនត្រឹមត្រូវទេ!",
  invalidCommission: "ការផ្ទេរមិនត្រឹមត្រូវទេ!",
  invalidRequestTime: "កាលបរិច្ឆេទចាប់ផ្តើមមិនត្រឹមត្រូវទេ!",
  invalidStatus: "កាលបរិច្ឆេទចាប់ផ្តើមមិនត្រឹមត្រូវទេ!",
  invalidAlgoMatchInfo: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidAlgoSliderLeagueInfo: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidAlgoSliderMinutesWeight: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidAlgoSliderBetType: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidRTSRunningScoreDetails: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidProviderGoalTimeLine: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidSliderTimeRange: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidMOMatchOdds: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidProviderSlider: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidCombineBetTypeAndOddsFormat: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  invalidMatchInformation: "វគ្គប្រកួតមិនត្រឹមត្រូវទេ!",
  marketClose: "ទីផ្សារនេះត្រូវបានបិទហើយ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",
  error: "ការប្រកួតមិនត្រឹមត្រូវទេ!",
  freeRoomNeedBet: "សូមដាក់ភ្នាល់ដែលត្រឹមត្រូវដើម្បីចូលរួមវគ្គប្រកួត។",
};
